import {Modal, message} from 'antd';
import fetch from '../fetch';


const saveSetting = (data) => {
   return fetch.post('jxcpReport/saveSetting' ,data)
}

const getSetting = () => {
    return fetch.get('jxcpReport/getSetting')
}

export default {
    saveSetting ,
    getSetting
}